import Vue from 'vue';
import Vuex from 'vuex';

import careService from './modules/careService';
import auth from './modules/auth';
import user from './modules/user';
import health from './modules/health';
import careLevelCalculator from './modules/careLevelCalculator';
import contentSheet from './modules/contentSheet';
import tasks from './modules/tasks';
import application from './modules/application';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    application,
    careService,
    auth,
    user,
    health,
    careLevelCalculator,
    contentSheet,
    tasks,
  },
});

export default store;
